import { render, staticRenderFns } from "./ShortCarSecurity.vue?vue&type=template&id=5ca3e2ba&scoped=true"
import script from "./ShortCarSecurity.vue?vue&type=script&lang=ts"
export * from "./ShortCarSecurity.vue?vue&type=script&lang=ts"
import style0 from "./ShortCarSecurity.vue?vue&type=style&index=0&id=5ca3e2ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca3e2ba",
  null
  
)

export default component.exports